export function isPackedValue(value) {
    return (value &&
        typeof value === "object" &&
        "useValue" in value &&
        typeof value.useValue === "function");
}
export const useUnpackedValue = (value) => {
    if (isPackedValue(value)) {
        return value.useValue();
    }
    return value;
};
useUnpackedValue.getLoadingView = (value, fallback) => {
    if (isPackedValue(value)) {
        return value.loadingView ?? fallback;
    }
    return fallback;
};
export default useUnpackedValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVW5wYWNrZWRWYWx1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VVbnBhY2tlZFZhbHVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCQSxNQUFNLFVBQVUsYUFBYSxDQUMzQixLQUEwQjtJQUUxQixPQUFPLENBQ0wsS0FBSztRQUNMLE9BQU8sS0FBSyxLQUFLLFFBQVE7UUFDekIsVUFBVSxJQUFJLEtBQUs7UUFDbkIsT0FBTyxLQUFLLENBQUMsUUFBUSxLQUFLLFVBQVUsQ0FDckMsQ0FBQztBQUNKLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxDQUFJLEtBQTBCLEVBQUssRUFBRTtJQUNuRSxJQUFJLGFBQWEsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDO1FBQ3pCLE9BQU8sS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDO0lBQzFCLENBQUM7SUFDRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQUVGLGdCQUFnQixDQUFDLGNBQWMsR0FBRyxDQUNoQyxLQUE0QixFQUM1QixRQUFzQixFQUNSLEVBQUU7SUFDaEIsSUFBSSxhQUFhLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUN6QixPQUFPLEtBQUssQ0FBQyxXQUFXLElBQUksUUFBUSxDQUFDO0lBQ3ZDLENBQUM7SUFDRCxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDLENBQUM7QUFFRixlQUFlLGdCQUFnQixDQUFDIn0=